function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M457.1,0H54.9C24.6,0,0,24.6,0,54.9v402.3C0,487.4,24.6,512,54.9,512h402.3c30.3,0,54.9-24.6,54.9-54.9V54.9 C512,24.6,487.4,0,457.1,0z M278.6,399.3c0,49.8-29.3,72.6-71.9,72.6c-38.5,0-60.8-19.9-72.2-44l39.2-23.7 c7.5,13.4,14.4,24.7,31,24.7c15.8,0,25.8-6.2,25.8-30.3V235.1h48.1L278.6,399.3L278.6,399.3z M392.5,471.9 c-44.7,0-73.6-21.3-87.7-49.1l39.2-22.6c10.3,16.8,23.8,29.3,47.4,29.3c19.9,0,32.7-9.9,32.7-23.8c0-16.5-13-22.3-35.1-32l-12-5.1 c-34.7-14.7-57.7-33.4-57.7-72.6c0-36.1,27.5-63.5,70.4-63.5c30.6,0,52.6,10.6,68.3,38.5l-37.5,24c-8.2-14.7-17.1-20.6-31-20.6 c-14.1,0-23,8.9-23,20.6c0,14.4,8.9,20.2,29.6,29.3l12,5.1c40.9,17.5,63.9,35.4,63.9,75.7C472.1,448.1,438.1,471.9,392.5,471.9 L392.5,471.9z"
});

function SvgJavascript(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.9f18f46f.svg";
export { ForwardRef as ReactComponent };